<p-dialog [(visible)]="isVisible" [style]="{ width: isFullScreen?'100vw':'75vw', maxWidth:  isFullScreen?'100vw':'1200px', height: isFullScreen?'100vh':'auto', maxHeight: isFullScreen?'100vh':'auto'}"
  styleClass="no-scroll-dialog" header="Vaka Oluşturma" (onHide)="close()"
  [draggable]="false" [resizable]="false" [modal]="true"   styleClass="no-scroll-dialog" #dialog>

  <div class="case-form-container">
    <div class="form-content">
      <form [formGroup]="form" class="p-fluid">
        <div class="form-grid p-col-12">
          <!-- Sol kolon -->
          <div class="left-column p-col-4">
            <div class="p-field">
              <label for="">Vaka Tipi*</label>
              <p-dropdown [options]="caseTypeOptions" formControlName="caseType" placeholder="Seçiniz">
              </p-dropdown>
            </div>
            <div class="p-field">
              <label for="">Telefon Numarası</label>
              <div class="phone-field">
                <p-dropdown [options]="countries" formControlName="country" [filter]="true" filterBy="name"
                  optionLabel="label" optionValue="value" appendTo="body" placeholder="+90"
                  styleClass="country-dropdown">
                  <ng-template let-country pTemplate="item">
                    <div class="country-option">
                      <div [innerHTML]="country.flag"></div>
                      <span>{{ country.label }}</span>
                    </div>
                  </ng-template>
                </p-dropdown>
                <input id="phone" type="tel"  class="form-control"  formControlName="phone" appPhoneMaskTR inputmode="numeric"
                  placeholder="(5xx) xxx xx xx" [class.is-invalid]="isInvalid('phone')" />
              </div>
            </div>

            <div class="p-field">
              <label for="">Hasta TCKN</label>
              <input id="tckn" type="text"  class="form-control"  maxlength="11" inputmode="numeric"  formControlName="tckn" [class.is-invalid]="isInvalid('tckn')" (keypress)="onlyDigit($event)"  />

            </div>
            <div class="p-field">
              <label for="">Hasta Cinsiyet</label>
              <p-dropdown [options]="genders" id="gender" formControlName="gender" [showClear]="true"
                [placeholder]="'case.patient-informations.gender' | translate" appendTo="body">
              </p-dropdown>
            </div>
            <div class="p-field">
              <label for="">Yaş</label>
              <input type="number" id="yas" class="form-control" formControlName="age"
                [placeholder]="'case.patient-informations.age' | translate" appPreventNegativeInput [min]="0" />
            </div>
          </div>

          <!-- Sağ kolon -->
          <div class="right-column p-col-8">
            <div class="name-row">
              <div class="p-field half-width">
                <label for="">Hasta Ad</label>
                <input type="text" class="form-control" formControlName="firstName" />
              </div>
              <div class="p-field half-width">
                <label for="">Hasta Soyad</label>
                <input type="text" class="form-control" formControlName="lastName" />
              </div>
            </div>

            <div class="p-field">
              <label for="">Şikayet</label>
              <textarea id="complaint" class="form-control" rows="3"
                [placeholder]="'medicalAdvice.complaint' | translate" formControlName="complaint"></textarea>
            </div>

            <div class="p-field">
              <label for="">Kullanıcı Notu</label>
              <textarea id="notlar" class="form-control" rows="2" [placeholder]="'medicalAdvice.userNote' | translate"
                formControlName="userNote"></textarea>
            </div>
            <div class="p-field">
              <core-address-input [form]="form" (openModal)="openAddressModal()"
                [showMapButton]="true"></core-address-input>
            </div>
            <div class="p-field">
              <label for="">Adres Açıklaması</label>
              <textarea id="addressNote" class="form-control" rows="2" formControlName="addressNote" (input)="onAddressNoteChange($event)"></textarea>
            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="dialog-footer">
      <button pButton label="İptal" class="p-button-danger" (click)="close()"></button>
      <button pButton label="Kaydet" class="p-button-success" (click)="save()"></button>
    </div>
  </div>
</p-dialog>

<core-address-autocomplete #addressComponent (setAddress)="onAddressSelected($event)">
</core-address-autocomplete>

<p-dialog [(visible)]="showSuccessDialog" [modal]="true" [style]="{ width: '400px' }" [showHeader]="false"
  [closable]="false">
  <div class="success-container">
    <h2>{{ caseTypeCode }}-{{ caseNo }}</h2>

    <i class="pi pi-copy pointer mx-2" (click)="copyText()" role="button"  tabindex="-1"></i>
    <div class="copy-notification" [class.show]="showNotification">
      {{ "case.copy" | translate }}
    </div>

    <div class="success-icon-container">
      <i class="pi pi-check-circle success-icon" (click)="closeAll()" role="button"  tabindex="-1"></i>
    </div>
  </div>
</p-dialog>
